import { Table } from '../table/Table';

import styles from './errorDetail.module.scss';

export type ErrorDetailProps = {
  fallbackText?: string;
  items: {
    message: string;
    row?: number;
    column?: string;
  }[];
};

export function ErrorDetail(props: ErrorDetailProps) {
  const { items, fallbackText } = props;
  const title = `Errors found: ${items.length}`;
  const columnDefs = [
    {
      field: 'context',
      headerName: 'Context',
      maxWidth: 300,
      cellClass: styles.errorDetailFirstCell,
    },
    {
      field: 'message',
      headerName: 'Message',
      suppressAutoSize: true,
      flex: 1,
      maxWidth: undefined,
      wrapText: true,
      autoHeight: true,
      cellClass: styles.errorDetailMessageCell,
    },
  ];

  const rowData = items.map((item) => {
    const rowPart = item.row != null ? `Row ${item.row}` : '';
    const colPart = item.column ? `Col ${item.column}` : '';
    const context =
      [rowPart, colPart].filter(Boolean).join(', ') || fallbackText || '';
    return { context, message: item.message };
  });

  return (
    <div>
      <p className={styles.errorDetailWidgetTitle}>{title}</p>
      <div className={styles.errorDetail}>
        <Table
          columnDefs={columnDefs}
          gridOptions={{ headerHeight: 0, suppressRowHoverHighlight: true }}
          rowData={rowData}
          onSortingChanged={() => undefined}
        />
      </div>
    </div>
  );
}
